export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_GatsbyJS-628bbd5735bc261a97f4971a31646792.jpg";